<div *ngIf="showWarning" class="content" [ngStyle]="positionWindow()">
  <i class="fa fa-exclamation-triangle text-danger"></i> <span translate> room.bad-con.text </span> <a target="_blank" href="{{getConnectionQualityErrorPageUrl()}}" translate>room.bad-con.info-link</a>
</div>
